/**
 * BlocAlerte (zone [3]) — bandeau pleine largeur conditionnel (blocage client,
 * certif expirée…). N'existe QUE si un contenu est fourni (jamais d'empty-state).
 */

import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { SummaryIcon } from '../primitives'
import { toneAlertClass } from '../primitives.helpers'
import type { SummaryAlert } from '../types'

export function SummaryAlertBlock({ alert }: { alert: SummaryAlert }) {
    const { t } = useTranslation()
    return (
        <div
            role="status"
            className={cn(
                'flex items-center gap-2 rounded-lg border px-3 py-2.5 text-xs font-medium',
                toneAlertClass(alert.tone),
            )}
        >
            <SummaryIcon name={alert.icon} className="h-4 w-4 shrink-0" />
            <span>{t(alert.message, { defaultValue: alert.message, ...(alert.params ?? {}) })}</span>
        </div>
    )
}
